import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { CustomIcon } from "components/icon/customIcon.component";
import { AutoCompleteInput } from "components/form/inputs/autoCompleteInput.component";
import { characterCounter, Text } from "components/Typography/text.styled";
import { ButtonStyled } from "components/buttons/buttons.styled";
import {
  SkillsWrapper,
  SkillInputWrapper,
  SkillTag,
} from "./saveGigForm.styled";
import { InputContainer } from "components/form/inputs/inputs.styled";
import { Skills } from "config/skillsMock";
import { RecruitFormData } from "./gigFormModal.component";
import { CompanyGigSkills } from "model/Gig";

type Props = {
  setFormData: React.Dispatch<React.SetStateAction<RecruitFormData>>;
  formData: RecruitFormData;
};

export const GigSkills: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [skillText, setSkillText] = useState("");

  const removeSkill = (skill: CompanyGigSkills) => {
    const hasDeleteEntry = "deleteEntry" in skill;

    if (hasDeleteEntry) {
      const newSkills = props.formData.skills.map((el) =>
        el === skill ? { ...el, deleteEntry: true } : el
      );
      props.setFormData((prev) => ({ ...prev, skills: newSkills }));
    } else {
      const newSkills = props.formData.skills.filter((el) => el !== skill);
      props.setFormData((prev) => ({ ...prev, skills: newSkills }));
    }
  };

  const addSkill = (value: string) => {
    const duplicate = props.formData.skills.find((el) => el.skill === value);

    if (duplicate && "deleteEntry" in duplicate && duplicate.deleteEntry) {
      const newSkills = props.formData.skills.map((el) =>
        el.skill === value ? { ...el, deleteEntry: false } : el
      );
      props.setFormData((prev) => ({ ...prev, skills: newSkills }));
    } else if (!duplicate) {
      const newSkills: CompanyGigSkills[] = [
        ...props.formData.skills,
        { skill: value, experience: 0 },
      ];
      props.setFormData((prev) => ({ ...prev, skills: newSkills }));
    }

    setSkillText("");
  };

  return (
    <>
      <InputContainer>
        <SkillInputWrapper>
          <AutoCompleteInput
            label={t("CreateShift.SkillsWanted")}
            inputValue={skillText}
            onChange={(val: string) => setSkillText(val)}
            submitValue={(value) => {
              if (value.length <= 24) addSkill(value);
            }}
            submittedValues={props.formData.skills.map((el) => el.skill)}
            selections={Skills.map((mockedSkill) =>
              t(mockedSkill, { ns: "skills" })
            )}
          />
          <ButtonStyled
            disabled={!skillText || skillText.length > 24}
            onClick={() => addSkill(skillText)}
          >
            {t("General.Add")}
          </ButtonStyled>
        </SkillInputWrapper>

        {characterCounter(24, skillText)}

        {props.formData.skills.length !== 0 && (
          <SkillsWrapper>
            {props.formData.skills.map((skill, index) => (
              <SkillTag key={`${skill.skill}-${index}`}>
                <Text
                  color={Color.White}
                  fontFamily={FontFamily.MontserratRegular}
                  fontSize={FontSize.Standard}
                  style={{ margin: 0 }}
                >
                  {t(skill.skill, { ns: "skills" })}
                </Text>
                <CustomIcon
                  name="cross"
                  size="16px"
                  color={Color.White}
                  onClick={() => removeSkill(skill)}
                />
              </SkillTag>
            ))}
          </SkillsWrapper>
        )}
      </InputContainer>
    </>
  );
};
